import { useState } from "react";

import axios from "axios";

import { useNavigate } from "react-router-dom";

import { BASE_URL } from "../services/api";

export default function SignUp() {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: "",
        username: "",
        password: "",
        partner_id: ""
    });

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await axios.post(
                `${BASE_URL}/auth/register`,
                formData
            );

            navigate("/login");

        } catch (err) {

            console.log(err);
        }
    };

    return (

        <div className="min-h-screen flex items-center justify-center bg-gray-100">

            <form
                onSubmit={handleSubmit}
                className="bg-white p-8 rounded shadow-md w-96"
            >

                <h2 className="text-2xl font-bold mb-6">
                    Partner Registration
                </h2>

                <input
                    type="text"
                    name="username"
                    placeholder="Username"
                    className="w-full border p-2 mb-4"
                    onChange={handleChange}
                />

                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    className="w-full border p-2 mb-4"
                    onChange={handleChange}
                />

                <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    className="w-full border p-2 mb-4"
                    onChange={handleChange}
                />

                <input
                    type="number"
                    name="partner_id"
                    placeholder="Partner ID"
                    className="w-full border p-2 mb-4"
                    onChange={handleChange}
                />

                <button
                    type="submit"
                    className="w-full bg-green-600 text-white py-2 rounded"
                >
                    Register
                </button>

            </form>

        </div>
    );
}